// imports
import { endPoints } from 'config/routes';
import { isTokenUnavailable, parseQueryString } from 'libs/auth';
import { encodeObjectToB64 } from 'libs/common';
import chargeBeeApplyAction, { CHARGEBEE_INIT, CHARGEBEE_LOGOUT } from 'libs/chargeBee';
import { AUTH_NOTIFICATION_MESSAGE } from 'libs/constants';
import {
  cleverTapLogout,
  logInAppProfile
} from 'libs/cleverTap';
import { applyRelativeToWindowPosition } from 'libs/windowDimension';
import { fetchUserApi } from 'api/auth';
import { getUserSubscriptionsApi } from 'api/subscriptions';
import { fetchIntroEligibilityApi } from 'api/offers';
import { notify } from './notice';
// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_USER = 'FETCH_USER';
export const ERROR_USER = 'ERROR_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';
export const RESET_USER = 'RESET_USER';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SET_PUBLIC_ACCESSIBLE = 'SET_PUBLIC_ACCESSIBLE';
export const FETCH_USER_SUBSCRIPTIONS = 'FETCH_USER_SUBSCRIPTIONS';
export const UPDATE_USER_SUBSCRIPTIONS = 'UPDATE_USER_SUBSCRIPTIONS';
export const UPDATE_USER_INTRO_ELIGIBILITY = 'UPDATE_USER_INTRO_ELIGIBILITY';
export const ERROR_USER_SUBSCRIPTIONS = 'ERROR_USER_SUBSCRIPTIONS';
export const ERROR_USER_INTRO_ELIGIBILITY = 'ERROR_USER_INTRO_ELIGIBILITY';

export function checkPublicAccessibleView() {
  const publicAccessibleEndpoints = [endPoints.products.ms.default, endPoints.redemptionActivate];
  let isPublicAccessible = false;
  if (publicAccessibleEndpoints.includes(window.location.pathname)) {
    isPublicAccessible = true;
  }
  return isPublicAccessible;
}

// ------------------------------------
// Actions
// ------------------------------------
export function updateUser(payload) {
  return ({ type: UPDATE_USER, payload });
}

export function updateUserEmail(payload) {
  return ({ type: UPDATE_USER_EMAIL, payload });
}

export function fetchUser() {
  return ({ type: FETCH_USER });
}

export function raiseErrorFechingUser() {
  return (dispatch) => {
    dispatch({ type: ERROR_USER });
  };
}

export function logoutUser() {
  return ({ type: USER_LOGOUT });
}

export function setPublicAccessible() {
  return ({ type: SET_PUBLIC_ACCESSIBLE });
}

export function resetUser(cb = () => {}) {
  return (dispatch) => {
    dispatch({ type: RESET_USER });
    cb();
  };
}

export function fetchUserSubscriptions() {
  return ({ type: FETCH_USER_SUBSCRIPTIONS });
}

export function updateUserSubscriptions(payload) {
  return ({ type: UPDATE_USER_SUBSCRIPTIONS, payload });
}

export function updateUserIntroEligibility(payload) {
  return ({ type: UPDATE_USER_INTRO_ELIGIBILITY, payload });
}

export function raiseErrorFechingUserSubscriptions() {
  return (dispatch) => {
    dispatch({ type: ERROR_USER_SUBSCRIPTIONS });
  };
}

export function raiseErrorFechingUserIntroElibility() {
  return (dispatch) => {
    ({ type: ERROR_USER_INTRO_ELIGIBILITY });
  };
}

export function getSigninRedirectUrl() {
  let url = endPoints.signin;
  if (window.location.pathname === endPoints.products.ms.default) {
    url = endPoints.msSignin;
  }
  return url;
}

export function handleLogoutUser(args = {}) {
  const { notificationMsg, redirectUrl, restrictRedirect } = args;
  //  Logout user from clevertap
  cleverTapLogout();
  return (dispatch) => {
    // clear storage
    localStorage.clear();
    // Clear store
    dispatch(logoutUser());
    // logout from chargeBee
    chargeBeeApplyAction(CHARGEBEE_LOGOUT);
    applyRelativeToWindowPosition();
    if (notificationMsg) {
      dispatch(notify({ message: notificationMsg }));
    }
    // redirect to signin page
    const redirect = redirectUrl || getSigninRedirectUrl();
    if (!restrictRedirect) {
      window.appHistory.push(redirect);
    }
  };
}
/*
 * @export function handleFetchUser action handler
 * loads the user from api
 */
export function handleFetchUser(args) {
  return (dispatch) => {
    dispatch(fetchUser());
    fetchUserApi(args)
      .then((res) => {
        // creates new user session and push the user details into clever tap
        // so that user can be identified for the events
        logInAppProfile(res.body);
        chargeBeeApplyAction(CHARGEBEE_INIT); // initialise Chargebee instance
        dispatch(updateUser(res.body));
      })
      .catch((error) => {
        dispatch(raiseErrorFechingUser());
        if (checkPublicAccessibleView()) {
          return;
        }
        dispatch(handleLogoutUser());
        dispatch(notify({ error }));
      });
  };
}

export function handleFetchUserSubscriptions(args) {
  return (dispatch) => {
    dispatch(fetchUserSubscriptions());
    getUserSubscriptionsApi(args)
      .then((res) => {
        dispatch(updateUserSubscriptions(res.body));
      })
      .catch((error) => {
        dispatch(raiseErrorFechingUserSubscriptions());
        dispatch(notify({ error }));
      });
  };
}

export function handleFetchUserIntroEligibleOffers(args) {
  return (dispatch) => {
    fetchIntroEligibilityApi(args)
      .then((res) => {
        dispatch(updateUserIntroEligibility(res.body));
      })
      .catch((error) => {
        dispatch(raiseErrorFechingUserIntroElibility());
        dispatch(notify({ error }));
      });
  };
}

export function getAuthUser(args, force = false) {
  const { intl } = args;
  return (dispatch, getState) => {
    const { auth: { info, isFetching }, windowLocation: { location } } = getState();
    // return i.e do nothing if user is already in store
    if (info && !force) {
      return;
    }
    // redirects to signIn if token not found or is expired
    if (isTokenUnavailable(location)) {
      if (checkPublicAccessibleView()) {
        dispatch(setPublicAccessible());
      } else {
        const isDefaultUrl = window.location.pathname === '/';
        // get url query
        const parsedQueryString = parseQueryString();
        const encodedRedirectQuery = encodeObjectToB64(parsedQueryString);

        dispatch(handleLogoutUser({
          notificationMsg: isDefaultUrl
            ? false
            : intl.formatMessage({ id: AUTH_NOTIFICATION_MESSAGE }),
          redirectUrl: isDefaultUrl ? '' : `${getSigninRedirectUrl()}?redirect=${window.appHistory.location.pathname}&query=${encodedRedirectQuery}`
        }));
        dispatch(raiseErrorFechingUser());
      }
    } else {
      // calls fetchUser action handler i.e get user from api as token is in local storage
      // but user is not
      dispatch(handleFetchUser(args));

      if (!isFetching) {
        dispatch(handleFetchUserSubscriptions(args));
        dispatch(handleFetchUserIntroEligibleOffers(args));
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js